import { Component, forwardRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { BirEditModalComponent } from '../../modal/bir-edit-modal/bir-edit-modal.component';
import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-pv-bir-select',
  templateUrl: './pv-bir-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PvBirSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class PvBirSelectComponent extends SelectBaseComponent {
  @ViewChild(BirEditModalComponent) birEditModal!: BirEditModalComponent;

  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = `IsCompany ne true and IsAP eq true`;
    if (searchValue) {
      const searchFields = [
        'code',
        'companyName',
        'firstName',
        'middleName',
        'lastName',
        'tinNumber',
        'tinBranchCode',
        'address'
      ];
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilter = searchFields
        .map(x => `contains(${x}, '${encodeURIComponent(searchStr)}')`)
        .join(' or ');
      filter = `${filter} and (${searchFilter})`;
    }
    return `api/BIRClassifications/Query?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  }

  addNew() {
    this.birEditModal.showNew({
      isAP: true
    });
  }

  selectBir(data: any) {
    if (data) {
      if (data.id) {
        this.valueChanged(data);
      } else {
        this.http.post('api/BIRClassifications/create', data).subscribe(res => {
          if (res) {
            this.list.push(res);
            this.valueChanged(res);
          }
        });
      }
    } else {
      this.valueChanged(data);
    }
  }
}
